import { useLocation } from "@reach/router";
import PropTypes from "prop-types";
/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";

import { useSiteMetadata } from "../hooks/useSiteMetadata";
import StructuredData from "./structuredData";

function Seo({
  title,
  image,
  translations = [],
  lang = { locale: `en_GB` },
  meta = [],
  description = ``,
  eventDetails = false,
  courseDetails = false,
  blogDetails = false,
  children
}) {
  const { pathname, host } = useLocation();
  const site = useSiteMetadata();

  //get page locale

  // console.log("seo - title", { title, description });

  const metaDescription = description || site?.siteMetadata?.description || "";
  const defaultTitle = !/world of difference/gi.test(title)
    ? [title, "World of Difference"].join(" | ")
    : title;
  const metaImage = image ?? "";

  const hreflang = [];
  const canonicalUrl = host ?? "[SEO_CANONICAL_URL]";
  const paginationLinks = [];

  const canonicals = [
    {
      rel: `canonical`,
      href: ["https://", canonicalUrl, pathname].join("")
    }
  ];

  return (
    <>
      <title>{defaultTitle}</title>
      {[
        {
          name: `description`,
          content: metaDescription
        },
        {
          property: `og:title`,
          content: title
        },
        {
          property: `og:description`,
          content: metaDescription
        },
        {
          property: `og:image`,
          content: metaImage?.sourceUrl ?? metaImage
        },
        {
          property: `og:type`,
          content: `website`
        },
        {
          name: `twitter:card`,
          content: `summary`
        },
        {
          name: `twitter:creator`,
          content: site?.siteMetadata?.author || ``
        },
        {
          name: `twitter:title`,
          content: title
        },
        {
          name: `twitter:description`,
          content: metaDescription
        }
      ]
        .concat(meta)
        .map((item, idx) => (
          <meta key={`${item.name}-${idx}`} {...item} />
        ))}

      {[]
        .concat(hreflang)
        .concat(canonicals)
        .concat(paginationLinks)
        .map((relItem, idx) => {
          return (
            <link
              key={`rel-link-${idx}`}
              rel={relItem.rel}
              href={relItem.href}
              hrefLang={relItem.hrefLang}
            />
          );
        })}
      <StructuredData
        key={"structured-data"}
        eventDetails={eventDetails}
        courseDetails={courseDetails}
        blogDetails={blogDetails}
      />
      {children}
    </>
  );
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.object,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
};

export default Seo;
